import { BTText } from "@btnet/core-components/BTText";

import { ClientObservableBackgroundJobStatus } from "types/enum";

import { BTTitle } from "commonComponents/btWrappers/BTTitle/BTTitle";
import { type ClientObservableBackgroundJobDetails } from "commonComponents/utilities/ClientObservableBackgroundJobStatusPopup/ClientObservableBackgroundJobStatusPopup.types";

/**
 * One document's row in the Bluebeam sync popup. Beyond the generic row it shows why a document
 * failed - Bluebeam's own wording where they gave any ("This file is password protected.") - since
 * a sync fans out per document and "one of these five failed, here's which and why" is the whole
 * point of watching it.
 */
export function BluebeamSyncItem({
    process,
}: Readonly<{ process: ClientObservableBackgroundJobDetails }>) {
    const isFailed = process.status === ClientObservableBackgroundJobStatus.Failed;
    const errorMessage = process.additionalData?.errorMessage;

    return (
        <>
            <BTTitle level={4} className="TruncateText margin-bottom-zero">
                {process.processName}
            </BTTitle>
            {isFailed && errorMessage && (
                <BTText
                    size="normal-sm"
                    testid="bluebeamSyncItemError"
                    className="text-fg-error whitespace-normal wrap-break-word"
                    text={errorMessage}
                />
            )}
        </>
    );
}
